module.exports = __webpack_public_path__ + "static/img/17.a8bbb80b.webp";